<template>
    <div class="user-label">
        <common-user-avatar class="user-label--avatar" size="label" :user="user"></common-user-avatar>

        <span>{{ userName }}</span>

        <div v-if="!isDisabled" class="user-label--close" @click="emitEvent({ name: 'close' })">
            <common-icon name="close-white" size="extra-small"></common-icon>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            user: { type: Object, required: true },
            isDisabled: { type: Boolean, default: false },
        },

        computed: {
            userName() {
                return this.user.name || `${this.user.firstName} ${this.user.lastName}`
            },
        },
    }
</script>
